<template>
  <md-field class="mb-4" :class="groupClass">
    <label>{{ label }}</label>
    <slot name="input">
      <md-input
        v-model.trim="validatorObject.$model"
        :type="inputType"
      ></md-input
    ></slot>
    <span class="md-helper-text">{{ helperText }}</span>
    <span class="md-error">
      <slot>
        <span
          v-if="
            validatorObject.hasOwnProperty('required') &&
              !validatorObject.required
          "
          >Field is required</span
        >
        <span
          v-else-if="
            validatorObject.hasOwnProperty('email') && !validatorObject.email
          "
          >Field must be a valid email address</span
        >
        <span
          v-else-if="
            validatorObject.hasOwnProperty('numeric') &&
              !validatorObject.numeric
          "
          >Field must only contain numbers</span
        >
        <span
          v-else-if="
            validatorObject.hasOwnProperty('minLength') &&
              !validatorObject.minLength
          "
          >Field must not be shorter than {{ inputMinLength }} characters</span
        >
        <span
          v-else-if="
            validatorObject.hasOwnProperty('maxLength') &&
              !validatorObject.maxLength
          "
          >Field must not be longer than {{ inputMaxLength }} characters</span
        >
      </slot>
    </span>
  </md-field>
</template>

<script>

export default {
  name: "FormGroup",
  props: {
    validatorObject: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: "Form Group"
    },
    helperText: {
      type: String,
      default: ""
    },
    inputType: {
      type: String,
      default: "text"
    },
    inputMinLength: {
      type: Number,
      default: 8
    },
    inputMaxLength: {
      type: Number,
      default: 255
    },
    googleId: {
      type: String,
      default: ""
    }
  },
  computed: {
    groupClass() {
      return {
        "md-invalid": this.validatorObject.$error
      };
    }
  }
};
</script>

<style></style>
